import { c as _c } from "react/compiler-runtime";
import { IdDocImageTypes } from '@onefootprint/types';
import { useEffect } from 'react';
import { trackAction } from '@/idv/utils';
import { ImgProcessorsContextProvider } from '../components/image-processors';
import { MissingPermissionsSheetProvider } from '../components/missing-permissions-sheet';
import { FaceModelProvider } from '../hooks/use-face-model-loader';
import { OpenCvGuard } from '../hooks/use-open-cv-guard';
import { OpenCvProvider } from '../hooks/use-open-cv-loader';
import { MachineProvider } from './components/machine-provider';
import Router from './pages/router';
import type { IdDocProps } from './types';
import type { MachineContext } from './utils/state-machine';
const IdDoc = t0 => {
  const $ = _c(21);
  const {
    initialContext,
    onDone
  } = t0;
  const {
    authToken,
    device,
    sandboxOutcome,
    requirement,
    config
  } = initialContext;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      country: undefined,
      type: undefined
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = device.initialCameraPermissionState || "prompt";
  let t3;
  if ($[1] !== authToken || $[2] !== config || $[3] !== device || $[4] !== requirement || $[5] !== sandboxOutcome || $[6] !== t2) {
    t3 = {
      authToken,
      device,
      requirement,
      isConsentMissing: requirement.config.shouldCollectConsent,
      currSide: IdDocImageTypes.front,
      idDoc: t1,
      allowPdf: false,
      sandboxOutcome,
      cameraPermissionState: t2,
      onboardingConfig: config
    };
    $[1] = authToken;
    $[2] = config;
    $[3] = device;
    $[4] = requirement;
    $[5] = sandboxOutcome;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const context = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(_temp, t4);
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <OpenCvGuard />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onDone) {
    t6 = <OpenCvProvider>{t5}<ImgProcessorsContextProvider><Router onDone={onDone} /></ImgProcessorsContextProvider></OpenCvProvider>;
    $[10] = onDone;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== requirement.config.shouldCollectSelfie || $[13] !== t6) {
    t7 = <FaceModelProvider isSelfieRequired={requirement.config.shouldCollectSelfie}>{t6}</FaceModelProvider>;
    $[12] = requirement.config.shouldCollectSelfie;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== device || $[16] !== t7) {
    t8 = <MissingPermissionsSheetProvider device={device}>{t7}</MissingPermissionsSheetProvider>;
    $[15] = device;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== context || $[19] !== t8) {
    t9 = <MachineProvider args={context}>{t8}</MachineProvider>;
    $[18] = context;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default IdDoc;
function _temp() {
  trackAction("id-doc:started");
}